import { z } from 'zod';

/////////////////////////////////////////
// USER PREFERENCES SCHEMA
/////////////////////////////////////////

export const UserPreferencesSchema = z.object({
  id: z.bigint(),
  user_id: z.number().int().nullable(),
  key: z.string().nullable(),
  name: z.string().nullable(),
  description: z.string().nullable(),
  value: z.string().nullable(),
  created_at: z.coerce.date(),
  updated_at: z.coerce.date(),
})

export type UserPreferences = z.infer<typeof UserPreferencesSchema>

export default UserPreferencesSchema;
